import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromCatalogApiActions from '../+state/actions/catalog-api.actions';

@Injectable({ providedIn: 'root' })
export class CatalogApiFacade {
  constructor(private store: Store) {}

  loadCatalogApiData() {
    this.store.dispatch(fromCatalogApiActions.LoadCatalogApi());
  }
}
